<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-29 10:19:14
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-10 10:46:38
 * @FilePath: \ces-vue-serve\src\views\Finance\components\editName.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div v-loading="loading">
    <div>
      <label class="lable">原客户名称:</label>
      <span class="changeName">{{ oldName }}</span>
    </div>
    <div class="mar_10">
      <label class="lable">修改后客户名称:</label>
      <el-input
        v-model.trim="newName"
        placeholder="请输入修改后客户名称"
        class="changeName"
        maxlength="200"
      /><span class="required">*</span>
    </div>
    <div class="mar_10">
      <label class="lable">委托付款说明文件:</label>
      <!-- <el-input v-model.trim="changeName" placeholder="请输入修改后客户名称" class="changeName" /> -->
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block; margin: 0 10px"
      >
        <el-button type="primary">
          上传附件
        </el-button>
      </el-upload>
      <el-button type="text" @click="dowmLoad">
        下载委托付款说明模板
      </el-button>
      <a ref="down" href="/修改客户的委托付款模板.docx" target="_blank" />
      <div v-for="(item, index) in fileList" :key="index" style="width: 100%;padding: 10px 0;">
        <span
          style="margin-right: 10px; color: #409eff"
          @click="fileClick(item)"
        >{{ item.fileName }}</span>
        <span style="color: #409eff; cursor: pointer" @click="deleteFile(index)"><i class="el-icon-error" /></span>
      </div>
      <!-- <el-button type="primary">下载</el-button> -->
    </div>
    <div class="mar_10">
      <label class="lable">历史审批意见:</label>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="mar_10"
      >
        <el-table-column prop="approver" label="审批人" align="left" />
        <el-table-column prop="approvalOpinion" label="审批内容" align="left" />
        <el-table-column prop="approvalTime" label="审批时间" align="left" />
        <el-table-column prop="approvalResult" label="是否同意" align="left">
          <template v-slot="{row}">
            <span v-if="row.approvalResult">同意</span>
            <span v-else>驳回</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>

import { handleEcho, attachmentGetToken } from '@/API';
import AxiosApi from '@/API/fileAxios';
export default {
  data () {
    return {
      oldName: '',
      newName: '',
      loading: false,
      tableData: [],
      // 文件参数
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: '',
      token: '',
      fileList: []
    };
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted () {
    this.initData();
    this.initToken();
  },
  methods: {
    dowmLoad () {
      this.$refs.down.click();
    },
    initData () {
      this.loading = true;
      handleEcho({ id: this.rowData.telApprovalId }).then((res) => {
        this.loading = false;
        const json = res.data;
        if (json.status === '200') {
          this.oldName = json.data.importCompany;
          this.newName = json.data.newImportCompany;
          this.fileList = json.data.fileList;
          this.tableData = json.data.approvalRecords;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    checkSpecialCharacters (str) {
      // return str.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '');
    // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    uploadaction (upload) {
      let lastLen = upload.file.name.lastIndexOf('.');
      let len = upload.file.name.length;
      let pathf = upload.file.name.substring(lastLen, len);
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      // pdf word 图片 压缩包
      // pdf doc docx jpg png gif zip  rar格式校验
      if (pathf !== '.pdf' && pathf !== '.doc' && pathf !== '.docx' && pathf !== '.jpg' && pathf !== '.png' && pathf !== '.gif' && pathf !== '.zip' && pathf !== '.rar') {
        this.$message.error('文件只允许pdf word 图片 压缩包上传！');
        return;
      }

      const isLt0M = upload.file.size > 31457280;
      if (isLt0M) {
        this.$message.error('上传文件大小不能大于30M!');
        return false;
      }
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.fileList.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID
          });
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    // 下载文件地址
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    deleteFile (tag) {
      this.fileList.splice(tag, 1);
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    }
  }
};
</script>

<style lang="scss">
.lable {
  width: 150px;
  display: inline-block;
}
.changeName {
  width: 200px;
  margin-left: 10px;
}
.mar_10{
  margin: 10px 0;
}
</style>
